import {remote} from '../constants/environment';
import {IDebtorItem} from '../interfaces/dtos';
import {defaultHeaders} from './headers';
import {IDebtorListResponse} from '../interfaces/services';
import {customFetch as fetch, remoteCall} from '../utils/services';

export const getDebtorsList = async (
  key: string,
  token: string,
): Promise<IDebtorListResponse> => {
  const remoteURI = remote.getDebtorsListUri(key);
  return (await remoteCall(
    async () => {
      return await fetch(remoteURI, {
        method: 'GET',
        headers: {
          ...defaultHeaders,
          'token-session': token,
        },
      });
    },
    async (response: Response) => {
      if (response.status === 201 || response.status === 200) {
        const data = await response.json();

        if (data.success && data.payload) {
          const success = true;

          return {
            success,
            payload: data.payload as IDebtorItem[],
          };
        } else {
          return {
            success: false,
            payload: null,
          };
        }
      }
    },
    remoteURI,
  )) as IDebtorListResponse;
};
